import Env from 'env-service'

const publicKey = Env.IS_PRODUCTION_CONNECTION
  ? 'pk_live_vTlzBMpVxKiGuxgeCqXLYLjw'
  : 'pk_test_XC7x5djznK1JbhUfIaZ0ZSJS'

export default publicKey